import { repositoriesRoutes } from '../router/RootRouter';
export function stripRouteParams(route) {
    return route.replace(/[:?]/g, '');
}
export function resolveUrlForRUM(match) {
    const correspondRoute = repositoriesRoutes.find((route) => route.path === match.path);
    if (correspondRoute) {
        return stripRouteParams(correspondRoute.path);
    }
    return match.url;
}
